var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"black-box"}),_c('div',{staticClass:"loadBottom",class:_vm.acuInfo.class},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img flex flex-center"},[_c('img',{staticStyle:{"height":"80px"},attrs:{"src":require("@/assets/imgs/yh.png")}})])
}]

export { render, staticRenderFns }